import DOMPurify from 'dompurify';
import { ContactCardProps } from '../../components/HelpPages/molecules/ContactCard';
import { RichText } from '../../components/HelpPages/atoms/RichText';

const localPurifier = DOMPurify();

export const mapToContactCardProps = (
	icon?: string | null,
	title?: string | null,
	textEditor?: string | null,
	linkLabel?: string | null,
	link?: string | null,
): ContactCardProps => {
	const sanitizedTextEditor = localPurifier.sanitize(textEditor || '');

	const result: ContactCardProps = {
		title: title || '',
		summary: textEditor && (
			<RichText richText={sanitizedTextEditor} className="text-xs my-4" />
		),
		link: {
			label: linkLabel || '',
			url: link || '',
		},
		linkColorOptions: {
			backgroundColor: 'primary',
			fontColor: 'primary',
		},
		colorOptions: {
			fontColor: 'primary',
			backgroundColor: 'primary',
		},
		// todo - project specific text to icon mapping
		icon,
	};

	return result;
};
